/*
 *  This file enterprise-wall.service.ts is part of HROne Inbox. The intelectual property owned by Uneecops Workplace Solution PVT. LTD.
 *  CopyrightYear: 2022
 *  (C) 2015-2022. All Right reserved. Uneecops Workplace Solution PVT. LTD.
 *
 */

import { Injectable } from '@angular/core';
import { SharedService } from 'src/app/global/services/shared.service';

import * as _ from 'lodash';
import moment from 'moment';

import { HttpService } from 'src/app/global/services/http-service';
import { LeaveType, monthDaysTill31 } from 'src/app/global/models/common.models';
import { SnackbarAlertService } from 'src/app/global/services/snackbar-alert.service';
import { WISH_TYPE, URLS, WISHES_ID, LeaveWidgetModel, DashboardWidgetItem, LeaveWidgetItem, ReferralJobOpeningItem, GoalLabelItem, WishListEntry } from './enterprise-wall.model';
import { ViewDetails } from '../performance/inbox/goal-cycle/card/goal-cycle-creation/goal-creation-detail/goal-creation.service';
import { IWishActionPayload, IFeedResponse } from '../enterprise-wall/social-enterpise-wall/social-wall.model';
import { JobOpeningRequestDetailModel } from '../recruitment/inbox/card/job-opening-details/job-opening-details.model';
import { TLabelSettingAPIResponse } from 'src/app/modules/recruitment/utilities/recruitmentAPI.model';
import { SearchEmployeeService } from 'src/app/global/services/search-employee.service';
import { ProgressButtonService } from 'src/app/global/services/progress-button.service';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { displayNamesConstant } from '../recruitment/inbox/card/recruitment.model';
import { HroneGlobalStateService } from 'src/app/store/global/global-state.service';

const PAGE_SIZE = 10;

@Injectable({
  providedIn: 'root'
})
export class EnterpriseWallService {

  companyApplicability!: boolean;
  isDashBoardCall!: boolean;

  perWishLoading!: boolean;
  perWishList: any = [];

  wishLoading!: boolean;
  wishList: any = [];
  wishLoadingSummary!: boolean;
  wishListSummary: any = [];
  wishPageNo = 1;
  wishIsMore!: boolean;
  isWishing!: boolean;
  selectedWishType: WISH_TYPE = 1;
  wishesCount = {
    birthday: 0,
    join_ann: 0,
    wed_ann: 0
  };

  taskLoading!: boolean;
  taskCount!: number;
  plannedLeaveCount!: number;

  notiCount!: number;
  notiCountLoading!: boolean;

  notiLoading!: boolean;
  notiList: { alertDate: string; list: any[] }[] = [];
  notiPageNo = 1;
  // notiIsMore: boolean;

  feedList: any[] = [];
  isFeedLoading!: boolean;
  feedPageNo!: number;
  showMoreFeed!: boolean;
  initialFeedCount = 0;
  newFeedCount = 0;

  profilePercent!: number;
  isProfileLoading!: boolean;

  currentMonth: any;
  currentYear: any;

  // widgetssss
  widgetLoading!: boolean;
  widgetList: DashboardWidgetItem[] = [];
  tempWidgetList: DashboardWidgetItem[] = [];

  initiativesCount = {
    assignByMe: 0,
    assignToTeam: 0,
    assignTome: 0,
  };
  widgetSequence = {
    EDR: {
      sequence: 1,
      flag: false,
      name: 'Directory',
      apiCalled: false
    },
    INTV: {
      sequence: 3,
      flag: false,
      name: 'Initiative',
      apiCalled: false
    },
    PNF: {
      sequence: 4,
      flag: false,
      name: 'Pending notification',
      apiCalled: false
    },
    INB: {
      sequence: 5,
      flag: false,
      name: 'Inbox',
      apiCalled: false
    },
    YAT: {
      sequence: 6,
      flag: false,
      name: 'Yesterday attendance',
      apiCalled: false
    },
    PRC: {
      sequence: 7,
      flag: false,
      name: 'Profile completion',
      apiCalled: false
    },
    SDA: {
      sequence: 8,
      flag: false,
      name: 'Continuous feedback',
      apiCalled: false
    },
    ORG: {
      sequence: 9,
      flag: false,
      name: 'ORG Chart',
      apiCalled: false
    },
    SHT: {
      sequence: 10,
      flag: false,
      name: 'Shortcut',
      apiCalled: false
    },
    TLW: {
      sequence: 11,
      flag: false,
      name: 'Team Leave',
      apiCalled: false
    },
    TLB: {
      sequence: 12,
      flag: false,
      name: 'Leave balance',
      apiCalled: false
    },
    TAC: {
      sequence: 13,
      flag: false,
      name: 'Calendar',
      apiCalled: false
    },
    EHP: {
      sequence: 14,
      flag: false,
      name: 'Goto HROne old version',
      apiCalled: false
    },
    GOAL: {
      sequence: 17,
      flag: false,
      name: 'Goal',
      apiCalled: false
    },
    OPS: {
      sequence: 16,
      flag: false,
      name: 'Open position',
      apiCalled: false
    },
    PLFT: {
      sequence: 20,
      flag: false,
      name: 'Planned leave for today',
      apiCalled: false
    }
  };

  leftColor!: string;
  tempLeftColor!: string;
  rightColor!: string;
  tempRightColor!: string;
  colorList = ['#dcdcdc', '#ebebeb', '#f4f4f4', '#f3eaf2', '#f0f2f8', '#e8f9ff', '#e3f5ec', '#fff8e8', '#ffefe7'];
  rightColorList = ['#dcdcdc', '#ebebeb', '#f4f4f4'];

  // Added by amit;
  globalBadgeList = [];

  isTodayCelebrationEmpty = false;
  isFeedsEmpty = false;

  isBadgeLimitGet = false;
  badgeLimit = {
    maxLimit: 0,
    current: 0
  };
  badgeList = [];

  isPointLimitGet = false;
  allPointsLimit = {
    maxLimit: 0,
    current: 0
  };

  // leave widget
  leaveLoading = false;
  leaveWidgetModel = new LeaveWidgetModel();
  leaveWidgetList: LeaveWidgetItem[] = [];
  leaveWidgetOuterList: { leaveDetails: LeaveWidgetItem[]; totalCount: number } = {
    leaveDetails: [],
    totalCount: 0
  };
  display_leave = false;

  tempLeaveFilter = {
    "employeeLeaveSearch": {} as { id: string },
    "fromDate": "",
    toDate: ''
  };

  count = 0;


  // jobOpning
  totalJobOpning!: ReferralJobOpeningItem[];
  jobPostingLoading = false;
  jobOpeningRequestDetails!: JobOpeningRequestDetailModel;
  labelList: TLabelSettingAPIResponse[] = [];
  display_refer_flyer = false;
  jobPostingInternlLoading = false;


  // shortcut
  shortcutWidgetList = [];
  shortCutLoader = false;


  loader = false;
  hroneV4Link!: string;

  list: { date: string }[] = [];
  colorObj: { [key: number]: { firstHalfStatusColor: string; secondHalfStatusColor: string; showAttendanceStatusOnCalendar: boolean } } = {};
  monthArry = monthDaysTill31;
  filter!: Promise<boolean>;
  CalnderList: { date: any; punchCount: number }[] = [];

  // goal wigdet
  isApprovedGoalAvailable = false;
  LabelList: GoalLabelItem[] = [];
  goalViewDetails!: ViewDetails;
  isGoalLoading = false;

  markAttSetting: any;
  showMarkAtt!: boolean;

  widgetSection: 'self' | 'hr' | 'manager' = 'self';
  managerWidgetAccess!: boolean;
  adminWidgetAccess!: boolean;

  fundraiserCampaignLoading!: boolean;
  fundraiserCampaignList: any = [];

  // Comment
  showHrPostchatInput!: boolean;
  commentRequestBody = {
    feedId: 0,
    pagination: {
      pageNumber: 0,
      pageSize: 5
    }
  }


  filterChips: any = {
    "reference": "",
    "sortOnUpdate": '',
    "postFor": '',
    "postBy": '',
  }

  filterObj: any = {
    "reference": "",
    "sortOnUpdate": '',
    "postFor": '',
    "postBy": '',
  }


  openCount!: number;
  jobopeningLoading = false;

  isFeatureApiHit = false;
  isCommentFeatureAvailable = false;
  employeeLateCount = 0;
  leaveTypeList: LeaveType[] = [];
  leaveTypeId: number[] = [];
  forPlannedLeaveToday = false;
  selectedFromDate = '';
  selectedToDate = '';

  constructor(
    public _shared: SharedService,
    public _http: HttpService,
    public _snackBar: SnackbarAlertService,
    public _searchEmployee: SearchEmployeeService,
    public _progressButton: ProgressButtonService,
    public _httpClient: HttpClient,
    private readonly _globalStateService: HroneGlobalStateService
  ) { }

  resetAllData() {
    this.isDashBoardCall = false;
    this.initialFeedCount = 0;
    this.newFeedCount = 0;

    this.isBadgeLimitGet = false;
    this.badgeLimit = {
      maxLimit: 0,
      current: 0
    };
    this.badgeList = [];

    this.isPointLimitGet = false;
    this.allPointsLimit = {
      maxLimit: 0,
      current: 0
    };

    this.widgetSection = 'self';
    this.managerWidgetAccess = false;
    this.adminWidgetAccess = false;
    this.resetFilter();
  }

  setColor() {
    const lColor: any = localStorage.getItem('leftColor');
    const rColor: any = localStorage.getItem('rightColor');
    if (lColor && rColor) {
      this.leftColor = lColor;
      this.rightColor = rColor;
    } else {
      this.leftColor = '#f4f4f4';
      this.rightColor = '#ebebeb';
    }

    this.tempLeftColor = this.leftColor;
    this.tempRightColor = this.rightColor;
  }

  resetWidgets() {
    for (const key of Object.keys(this.widgetSequence)) {
      this.widgetSequence[key as keyof typeof this.widgetSequence].apiCalled = false;
    }
  }

  getWidgets(): Promise<any> {
    this.resetWidgets();
    return new Promise((resolve, reject) => {

      this.widgetLoading = true;
      this.widgetList = [];
      const url = URLS.widgets;
      this._http.Get(url).subscribe(res => {
        if (res?.length) {
          this.widgetList = res;
          this.widgetList = this.widgetList.filter(widget => widget.masterWidgetId !== 3);
        }

        this.manipulateWidgets();

        this.widgetLoading = false;
        resolve(true);
      }, () => {
        this.widgetLoading = false;
        reject(new Error());
      });

    });
  }

  manipulateWidgets() {

    this.widgetList = _.sortBy(this.widgetList, [e => e.sequenceNumber]);

    let localList: any = localStorage.getItem('widgetList');
    if (localList) {
      localList = JSON.parse(localList);
    }

    if (localList?.length && (localList.length === this.widgetList.length)) {
      let isMatched = true;
      for (const widget of this.widgetList) {
        const fi = localList.findIndex((ele: any) => ele.widgetType === widget.widgetType
          && ele.widgetName === widget.widgetName);
        if (fi < 0) {
          isMatched = false;
          break;
        }
      }

      if (isMatched) {
        this.widgetList = localList;
      } else {
        this.widgetList.forEach(ele => {
          ele.flag = true;
        });
      }
    } else {
      this.widgetList.forEach(ele => {
        ele.flag = true;
      });
    }

    this.tempWidgetList = _.cloneDeep(this.widgetList);
    localStorage.setItem('widgetList', JSON.stringify(this.widgetList));
    this.widgetSequencing();
  }

  widgetSequencing() {
    for (let i = 0; i < this.widgetList.length; i++) {
      const wgt = this.widgetSequence[this.widgetList[i].widgetType as keyof typeof this.widgetSequence];
      if (wgt) {
        wgt.sequence = i + 1;
        wgt.flag = this.widgetList[i].flag;
        wgt.name = this.widgetList[i].widgetName;
      }
    }
  }

  getPerWishes() {
    this.perWishLoading = true;
    this.perWishList = [];

    const url = URLS.perWishes + '0/0/0';

    const wishes = this._http.Get(url);
    const wished = this._http.Get(URLS.wishedMe);

    forkJoin([wishes, wished]).subscribe(response => {
      if (response[0]?.wishes) {
        this.perWishList = response[0].wishes;
        for (const wish of this.perWishList) {
          wish.list = [];
        }
      }

      if (response[1]) {
        const res = response[1];
        for (const item of res) {
          const fi = this.perWishList.findIndex((ele: any) => ele.wishesTypeId === item.wishesTypeId);
          if (fi >= 0) {
            this.perWishList[fi].list.push(item);
          }
        }
      }

      this.perWishLoading = false;
    }, () => {
      this.perWishLoading = false;
    });

  }

  getWishes(key: 'summary' | 'all', more = false) {
    return new Promise((resolve) => {
      this.initializeWishPagination(more);
      const typeId = this.getTypeIdAndSetLoading(key);
      const url = URLS.wishes + typeId + '/' + this.wishPageNo + '/' + PAGE_SIZE + '/' + true;

      this._http.Get(url).subscribe(result => {
        if (result) {
          const res = result.wishes;
          this.markAlreadyWished(res);

          if (key === 'summary') {
            this.processSummaryResult(result, res);
          } else {
            this.processAllResult(res, more);
          }
        }

        this.setWishLoading(key, false);
        resolve(true);
      }, () => {
        this.setWishLoading(key, false);
      });
    });
  }

  private initializeWishPagination(more: boolean) {
    if (more) {
      this.wishPageNo += 1;
    } else {
      this.wishList = [];
      this.wishPageNo = 1;
    }
  }

  private getTypeIdAndSetLoading(key: 'summary' | 'all'): number {
    if (key === 'all') {
      this.wishLoading = true;
      return this.selectedWishType;
    }
    this.wishLoadingSummary = true;
    return 0;
  }

  private getWishedListFromStorage(): any[] {
    const wishedList = localStorage.getItem('wishedList');
    return wishedList ? JSON.parse(wishedList) : [];
  }

  private markAlreadyWished(res: any[]) {
    const wishedList = this.getWishedListFromStorage();
    const myId = this._shared.logOnUserDetails.employeeId;

    for (const wished of wishedList) {
      const fi = res.findIndex(ele =>
        ele.employeeId === wished.employeeId &&
        myId === wished.myId &&
        ele.wishesTypeId === wished.wishesTypeId
      );
      if (fi >= 0) {
        res[fi].isWished = true;
      }
    }
  }

  private processSummaryResult(result: any, res: any[]) {
    this.wishListSummary = res;
    this.isTodayCelebrationEmpty = !this.wishListSummary.length;
    this.updateWishesCount(result.wishesCount);
  }

  private updateWishesCount(wishesCount: any[]) {
    try {
      const birth = wishesCount?.find(ele => ele.wishesTypeId === WISHES_ID.birthday);
      const join = wishesCount?.find(ele => ele.wishesTypeId === WISHES_ID.joining_anniv);
      const wed = wishesCount?.find(ele => ele.wishesTypeId === WISHES_ID.wedding_anniv);

      this.wishesCount.birthday = birth?.count ?? 0;
      this.wishesCount.join_ann = join?.count ?? 0;
      this.wishesCount.wed_ann = wed?.count ?? 0;
    } catch {
      // Handle error silently
    }
  }

  private processAllResult(res: any[], more: boolean) {
    this.wishList = more ? _.concat(this.wishList, res) : res;
    this.wishIsMore = res?.length >= PAGE_SIZE;
  }

  private setWishLoading(key: 'summary' | 'all', loading: boolean) {
    if (key === 'all') {
      this.wishLoading = loading;
    } else {
      this.wishLoadingSummary = loading;
    }
  }

  onWishAction(wish: WishListEntry, reqData: IWishActionPayload) {
    this.isWishing = true;
    const url = URLS.wishAction;

    this._http.Post(url, reqData).subscribe(res => {
      this._snackBar.Alert(res.message, res.validationType);

      if (res.validationType === '0') {
        wish.isWished = true;

        // save wished msg in local storage
        let wishedList: any = localStorage.getItem('wishedList');
        if (wishedList) {
          wishedList = JSON.parse(wishedList);
        } else {
          wishedList = [];
        }
        wishedList.push({
          employeeId: wish.employeeId,
          wishesTypeId: wish.wishesTypeId,
          date: (new Date()).getTime(),
          myId: this._shared.logOnUserDetails.employeeId
        });
        localStorage.setItem('wishedList', JSON.stringify(wishedList));
        // end save wished msg in local storage
      }
      this.isWishing = false;
    }, () => {
      this.isWishing = false;
    });
  }

  getTaskCount() {
    this.taskLoading = true;
    this.taskCount = 0;
    const url = URLS.taskCount;
    this._http.Get(url).subscribe(res => {
      if (res) {
        this.taskCount = res.taskCount;
      }
      this.taskLoading = false;
    }, () => {
      this.taskLoading = false;
    });
  }

  getNotiCount() {
    this.notiCountLoading = true;
    this._http.Get(URLS.notiCount).subscribe(res => {
      this.notiCount = Number(res);
      this.notiCountLoading = false;
    }, () => {
      this.notiCountLoading = false;
    });
  }

  getNotification(more?: boolean): Promise<any> {
    return new Promise((resolve) => {

      this.notiLoading = true;

      if (more) {
        this.notiPageNo += 1;
      } else {
        this.notiList = [];
        this.notiPageNo = 1;
      }

      const url = URLS.notification + this.notiPageNo + '/' + PAGE_SIZE;

      this._http.Get(url).subscribe(res => {
        if (res) {

          for (const item of res) {

            const myd = this.dateConverter(item.alertDate);

            const fi = this.notiList.findIndex((ele) => ele.alertDate === myd);
            if (fi >= 0) {
              this.notiList[fi].list.push(item);
            } else {
              this.notiList.push({
                alertDate: myd,
                list: [item]
              });
            }

          }

        }
        this.notiLoading = false;
        resolve(true);
      }, () => {
        this.notiLoading = false;
      });

    });
  }

  dateConverter(alertDate: string) {
    const date = moment(alertDate).format('DD/MM/YYYY');
    const today = moment().format('DD/MM/YYYY');
    const yesterday = moment().subtract(1, 'day').format('DD/MM/YYYY');
    let myd;
    if (date === today) {
      myd = 'Today';
    } else if (date === yesterday) {
      myd = 'Yesterday';
    } else {
      myd = date;
    }

    return myd;
  }
  addPropertyForCustomBadge(feed: IFeedResponse & { imageId?: string; color?: string }) {
    if (feed.reference === 'Badge' && feed.customStatus) {
      const badge = this._shared.customBadges.find(b => feed.feedImage === b.imageName);
      if (badge) {
        feed.imageId = feed.feedImage;
        feed.feedImage = badge.path;
        feed.color = badge.color;
      }
    }
  }
  addComment(feed: IFeedResponse & { commentList: any[]; viewComment?: boolean }) {
    if (feed.commentsCount) {
      this.commentRequestBody.feedId = feed.feedId;
      if (feed.commentList.length) {
        this.commentRequestBody.pagination.pageNumber += 1;
        this.commentRequestBody.pagination.pageSize = 5;
      } else {
        this.commentRequestBody.pagination.pageNumber = 1;
        this.commentRequestBody.pagination.pageSize = 5;
        feed.commentList = [];
      }
      this._http.Post('/api/Engage/Badge/FeedCommentDetail', this.commentRequestBody).subscribe(response => {
        if (response?.length) {
          if (feed.commentList.length) {
            feed.commentList = _.concat(feed.commentList, response);
          } else {
            feed.commentList = response;
          }
          const distinct = _.uniqBy([...feed.commentList], 'commentId');
          feed.commentList = distinct;
          if (feed.commentList.length > 0) {
            feed.viewComment = response.length >= 5;
          }
        }
      }, () => { });
    }
  }
  getFeeds(more = false): Promise<any> {
    return new Promise((resolve) => {
      this.isFeedLoading = true;
      this.initializeFeedPagination(more);

      const url = URLS.feeds;
      this.makeFilterReq();
      const reqData = this.buildFeedRequest();

      this._http.Post(url, reqData).subscribe(response => {
        if (response) {
          this.processFeedResponse(response, more);
        }
        this.isFeedLoading = false;
        resolve(true);
      }, () => {
        this.isFeedLoading = false;
      });
    });
  }

  private initializeFeedPagination(more: boolean) {
    if (more) {
      this.feedPageNo += 1;
    } else {
      this.feedList = [];
      this.feedPageNo = 1;
      this.showMoreFeed = false;
      this.initialFeedCount = 0;
      this.newFeedCount = 0;
    }
  }

  private buildFeedRequest() {
    return {
      reference: this.filterObj.reference ? this.filterObj.reference.id : '',
      sortOnUpdate: this.filterObj.sortOnUpdate?.id === 'SOU',
      postFor: this.filterObj.postFor ? this.filterObj.postFor.id : 0,
      postBy: this.filterObj.postBy ? this.filterObj.postBy.id : 0,
      userCompanyId: this._shared.logOnUserDetails?.companyCode ? Number(this._shared.logOnUserDetails?.companyCode) : 0,
      pagination: {
        pageNumber: this.feedPageNo,
        pageSize: PAGE_SIZE
      }
    };
  }

  private processFeedResponse(res: any[], more: boolean) {
    for (const item of res) {
      this.initializeFeedItem(item);
      this.processMediaList(item);
    }

    const mappedFeeds = this.mapEndorsementFeeds(res);

    if (more) {
      this.feedList = _.concat(this.feedList, mappedFeeds);
    } else {
      this.feedList = mappedFeeds;
      this.isFeedsEmpty = !this.feedList.length;
    }

    this.showMoreFeed = res.length === PAGE_SIZE;
  }

  private initializeFeedItem(item: any) {
    item.imageList = [];
    item.videoList = [];
    item.commentList = [];
    item.showChatInput = false;
    if (item.commentsCount) {
      item.viewComment = true;
    }
    this.addPropertyForCustomBadge(item);
  }

  private processMediaList(item: any) {
    if (!item.imageAndVideoList?.length) {
      return;
    }

    for (const media of item.imageAndVideoList) {
      if (media.imageOrVideo === 'I') {
        item.imageList.push({
          source: media.path,
          thumbnail: media.compressImagePath || media.path
        });
      } else {
        item.videoList.push({ source: media.path });
      }
    }
  }

  private mapEndorsementFeeds(feeds: any[]): any[] {
    return feeds.map(feed => {
      if (feed.reference === 'Endorsement') {
        return this.handleSkillSplitting(feed);
      }
      return feed;
    });
  }
  handleSkillSplitting(feed: any): any {
    const arr = feed.remarks.split('~');
    feed.skill = arr.slice(1).join("~");
    feed.remarks = arr[0];
    return feed;
  }

  getFeedCount(initial?: boolean) {
    this._http.Get(URLS.feedCount).subscribe(res => {
      if (res) {
        if (initial || !this.initialFeedCount) {
          this.initialFeedCount = res;
        } else {
          this.newFeedCount = res - this.initialFeedCount;
        }
      }
    });
  }


  getProfileCompletion() {
    this.isProfileLoading = true;
    this._http.Get(URLS.profile).subscribe(res => {
      if (res) {
        this.profilePercent = res;
      }
      this.isProfileLoading = false;
    }, () => {
      this.isProfileLoading = false;
    });
  }

  getCompApplicability() {
    this.companyApplicability = this._shared.getDirectoryFilter == 1;
  }

  getBadgeLimit() {
    this.badgeLimit = {
      maxLimit: 0,
      current: 0
    };
    this._http.Get(URLS.badgeLimit + this._shared.logOnUserDetails.employeeId).subscribe(res => {
      if (res) {
        this.badgeLimit = res;
      }
      this.isBadgeLimitGet = true;
    }, () => {
      this.isBadgeLimitGet = true;
    });
  }

  getPointLimit() {
    this.allPointsLimit.maxLimit = 0;
    this.allPointsLimit.current = 0;

    const url = URLS.pointLimit + 0;

    this._http.Get(url).subscribe(res => {
      if (res) {
        this.allPointsLimit.maxLimit = res.totalPoint;
        this.allPointsLimit.current = res.usedPoints;
      }
      this.isPointLimitGet = true;
    }, () => {
      this.isPointLimitGet = true;
    });
  }

  getLeaveWidget(more?: boolean, fromFilter?: boolean): Promise<any> {
    return new Promise((resolve) => {

      this.leaveLoading = true;

      if (more) {
        this.leaveWidgetModel.pagination.pageNumber += 1;
      } else {
        this.leaveWidgetList = [];
        if (!fromFilter) {
          this.leaveWidgetOuterList.leaveDetails = [];
        }
        this.leaveWidgetModel.pagination.pageNumber = 1;
      }

      this._http.Post(URLS.leaveWidget, this.leaveWidgetModel).subscribe(res => {
        if (res) {
          res.leaveDetails.forEach((element: LeaveWidgetItem) => {
            const date1 = moment(element.leaveFromDate);
            const date2 = moment(element.leaveToDate);
            if (date1.isSame(date2)) {
              element['isSameDay'] = true;
            } else {
              element['isSameDay'] = false;
            }
          });
          if (more) {
            this.leaveWidgetList = this.leaveWidgetList.concat(res.leaveDetails);
          } else {
            this.leaveWidgetList = res.leaveDetails;
            if (!fromFilter) {
              this.leaveWidgetOuterList.leaveDetails = res.leaveDetails;
              this.leaveWidgetOuterList.totalCount = res.totalCount;
            }

          }
        }
        this.leaveLoading = false;
        resolve(true);
      }, () => {
        this.leaveLoading = false;
      });

    });
  }

  getTotalJobOpning() {
    this.jobPostingLoading = true;
    const req_data = {
      "positionId": 0,
      "pagination": {
        "pageNumber": 1,
        "pageSize": 1000
      }
    };
    this._http.Post('/api/recruitment/referralposting', req_data).subscribe(response => {
      this.totalJobOpning = response;
      if (this.totalJobOpning?.length) {
        this.totalJobOpning.forEach((element) => {
          if (element.referralMessage && element.referralMessage.length >= 30) {
            element['shortReferralMessage'] = element.referralMessage.slice(0, 30);
            element['isSeeMore'] = true;
            element['labelNameSeeMore'] = 'See more';
          } else {
            element['shortReferralMessage'] = element.referralMessage;
            element['isSeeMore'] = false;
          }
        });
      }
    }, () => {
      this.jobPostingLoading = false;
      this.totalJobOpning = [];
    });
  }

  getFundraiserCampaignList() {
    this.fundraiserCampaignLoading = true;
    const req_data = {
      "fundraiserId": 0,
      "pagination": {
        "pageNumber": 1,
        "pageSize": 1000
      }
    };
    this._http.Post('/api/engage/covid/fundraiser/Master/Details', req_data).subscribe(response => {
      this.fundraiserCampaignList = response ?? [];
      this.fundraiserCampaignLoading = false;
    }, () => {
      this.fundraiserCampaignLoading = false;
      this.fundraiserCampaignList = [];
    });
  }


  openForm(requestData: any) {
    this.jobPostingInternlLoading = true;
    this.getLabelSetting();
    setTimeout(() => {
      this.getJobOpeningDetails(requestData.positionId, requestData.postedById);
    }, 100);
  }

  getJobOpeningDetails(requestId: any, employeeId: any) {
    const req = {
      "requestId": requestId,
      "requestBy": employeeId,
      "transactionId": null
    };
    const url = '/api/recruitment/JobOpening/Request/Details';
    this._http.Post(url, req).subscribe(res => {
      this.jobOpeningRequestDetails = res;
      this.jobPostingLoading = false;
      this.jobPostingInternlLoading = false;
    }, () => {
      this.jobPostingLoading = false;
    });
  }

  getLabelSetting() {
    const req_data = { "isCarrierPortal": false, "isReferralPost": true, "isCandidate": false, numberOfRows: 4 };
    this._http.Post('/api/recruitment/label/setting', req_data).subscribe(res => {
      this.labelList = res;
    });
  }


  getDisplayName(key: string) {
    const fi = this.labelList.findIndex(data => data.fieldName.toLowerCase() === key.toLowerCase());
    if (fi >= 0) {
      return this.labelList[fi].displayName;
    } else {
      // tslint:disable-next-line: no-use-before-declare
      return displayNamesConstant[key as keyof typeof displayNamesConstant];
    }
  }

  ifVisible(key: string) {
    const fi = this.labelList.findIndex(data => data.fieldName.toLowerCase() === key.toLowerCase());
    if (fi >= 0 && this.labelList[fi].isReferralPost) {
      return true;
    } else {
      return false;
    }
  }




  // CAlender
  onMonthChange(event: { year: number; month: number }) {
    this.loader = true;
    this.filter = Promise.resolve(true);
    this.list = [];
    this.colorObj = {};
    const req_data = {
      attendanceYear: event.year,
      attendanceMonth: event.month,
      employeeId: this._shared.logOnUserDetails.employeeId
    };
    const url = "/api/timeoffice/attendance/Calendar";
    this._http.Post(url, req_data).subscribe(response => {
      if (response) {
        this.processCalendarResponse(response);
      } else {
        this.resetCalendarState();
      }
      this.loader = false;
      this.filter = Promise.resolve(false);
    }, () => {
      this.resetCalendarState();
    });
  }

  private processCalendarResponse(response: any[]) {
    this.CalnderList = response.filter(data => data.oddEvenIndication)
      .map(e => ({ date: e.attendanceDate, punchCount: e.oddEvenCount }));
    this.employeeLateCount = this._shared.getEmployeeLateCount(response);

    for (const datecount of this.monthArry) {
      const object = response.find(ele => datecount === moment(ele.attendanceDate).date());
      if (object) {
        this.processCalendarDate(datecount, object);
      } else {
        this.list.push({ date: "" });
      }
    }
  }

  private processCalendarDate(datecount: number, object: any) {
    this.colorObj[datecount] = {
      firstHalfStatusColor: object.firstHalfStatusColor,
      secondHalfStatusColor: object.secondHalfStatusColor,
      showAttendanceStatusOnCalendar: object.showAttendanceStatusOnCalendar
    };

    const listDate = this.getListDateValue(object);
    this.list.push({ date: listDate });

    if (listDate === "" && !object.showAttendanceStatusOnCalendar) {
      this.adjustHalfStatusColors(datecount, object);
    }
  }

  private getListDateValue(object: any): string {
    const firstHalf = object.updatedFirstHalfStatus;
    const secondHalf = object.updatedSecondHalfStatus;

    const isBothSame = (firstHalf === "P" && secondHalf === "P") || (firstHalf === "A" && secondHalf === "A");
    if (isBothSame) {
      return "NC";
    }

    if (firstHalf === "-" && secondHalf === "-") {
      return "DN";
    }

    return "";
  }

  private adjustHalfStatusColors(datecount: number, object: any) {
    if (object.updatedFirstHalfStatus === "P" || object.updatedFirstHalfStatus === "A") {
      this.colorObj[datecount].firstHalfStatusColor = '#00000000';
    }
    if (object.updatedSecondHalfStatus === "P" || object.updatedSecondHalfStatus === "A") {
      this.colorObj[datecount].secondHalfStatusColor = '#00000000';
    }
  }

  private resetCalendarState() {
    this.list = [];
    this.colorObj = {};
    this.loader = false;
  }

  getHroneV4Link() {
    const authlogin = JSON.parse(localStorage.getItem('authlogin') ?? 'null');
    const accessToken = authlogin ? authlogin.access_token : '';
    this._globalStateService.getEnterprise().subscribe(res => {
      if (res?.length) {
        this.hroneV4Link = res[0].hrOneV4BasePath + accessToken;
      }
    });
  }

  getPerformanceInititiveCount() {
    const url = `/api/pms/initiative/widget/Count/${this._shared.logOnUserDetails.employeeId}`;
    this._http.Get(url).subscribe(response => {
      if (response) {
        this.initiativesCount = response;
      }
    });
  }

  // goal widget
  getLAstApprovedData() {
    this.isApprovedGoalAvailable = true;
    this.isGoalLoading = true;
    this._http.Get(`/api/pms/goal/requestFlow/LastApprovedGoalForEdit/${this._shared.logOnUserDetails.employeeId}`).subscribe(res => {
      if (res) {
        const event = {
          requestId: res.goalCreationRequestId,
          level: 0,
          employeeId: this._shared.logOnUserDetails.employeeId
        };
        this.getGoalDetails(event);
      } else {
        this.isApprovedGoalAvailable = false;
        this.isGoalLoading = false;
      }
    }, () => {
      this.isGoalLoading = false;
      this.isApprovedGoalAvailable = false;
    });
  }

  getGoalDetails(event?: any) {
    this.getLableList();
    if (event['requestId'] == 0) return;
    if (event) {
      setTimeout(() => {
        this._http.Get(`/api/pms/goal/requestFlow/${event['requestId']}/${event['level']}`).subscribe(data => {
          this.goalViewDetails = data;
          this.isGoalLoading = false;
        }, () => {
          this.isGoalLoading = false;
        });
      }, 100);
    }
  }

  getLableList() {
    this._http.Get('/api/core/performance/setting/LabelName').subscribe(response => {
      this.LabelList = response ?? [];
    });
  }

  getGoalDisplayName(key: string) {
    if (key && this.LabelList?.length) {
      const fi = this.LabelList.findIndex(data => data.systemName.toLowerCase() === key.toLowerCase());
      if (fi >= 0) {
        return this.LabelList[fi].displayName;
      } else {
        return displayNamesConstant[key as keyof typeof displayNamesConstant];
      }
    }
  }

  getcommentCheers(com: any) {
    return new Promise((resolve, reject) => {
      this._http.Get(`/api/Engage/Badge/CommentReactionDetails/${com.commentId}`).subscribe(response => {
        if (response) {
          resolve(response);
        }
      }, error => { reject(new Error(error)) });
    }).catch(() => { })
  }

  getJobOpeningeWidget() {
    this.openCount = 0;
    this.jobopeningLoading = true;
    this._http.Get(`/api/recruitment/position/Open/Close/Count/${this._shared.logOnUserDetails.employeeId}`).subscribe((res: any) => {
      this.jobopeningLoading = false;
      if (res) {
        this.openCount = res.openCount;

      }
    });
  }


  makeFilterReq() {
    this.filterChips.reference = this.filterObj.reference;
    this.filterChips.sortOnUpdate = this.filterObj.sortOnUpdate;
    this.filterChips.postFor = this.filterObj.postFor;
    this.filterChips.postBy = this.filterObj.postBy;

  }

  resetFilter() {
    this.filterObj.reference = '';
    this.filterObj.sortOnUpdate = '';
    this.filterObj.postFor = '';
    this.filterObj.postBy = '';
  }

  getPlannedLeaveCount() {
    this.taskLoading = true;
    this.plannedLeaveCount = 0;
    const url = URLS.plannedLeaveCount;
    this._http.Get(url).subscribe(res => {
      if (res) {
        this.plannedLeaveCount = res;
      }
      this.taskLoading = false;
    }, () => {
      this.taskLoading = false;
    });
  }

  getTodayLeaveWidget(more?: boolean, fromFilter?: boolean) {
    return new Promise((resolve) => {
      this.leaveLoading = true;

      if (more) {
        this.leaveWidgetModel.pagination.pageNumber += 1;
      } else {
        this.leaveWidgetList = [];
        if (!fromFilter) {
          this.leaveWidgetOuterList.leaveDetails = [];
        }
        this.leaveWidgetModel.pagination.pageNumber = 1;
      }

      this._http.Post(URLS.leaveWidgetPlanned, this.leaveWidgetModel).subscribe(res => {
        if (res?.leaves?.length) {
          res.leaves.forEach((element: any) => {
            const date1 = moment(element.leaveFromDate);
            const date2 = moment(element.leaveToDate);
            if (date1.isSame(date2)) {
              element['isSameDay'] = true;
            } else {
              element['isSameDay'] = false;
            }
          });
          if (more) {
            this.leaveWidgetList = this.leaveWidgetList.concat(res.leaves);
          } else {
            this.leaveWidgetList = res.leaves;
            if (!fromFilter) {
              this.leaveWidgetOuterList.leaveDetails = res.leaves;
              this.leaveWidgetOuterList.totalCount = res.totalCount;
            }
          }
        }
        this.leaveLoading = false;
        resolve(true);
      }, () => {
        this.leaveLoading = false;
      });

    });
  }

  getLeavetype() {
    const url = '/api/timeoffice/setting/leave/Type';
    this._http.Get(url).subscribe(response => {
      this.leaveTypeList = response ?? [];
      if (response?.length) {
        this.leaveTypeList = response.map((e: any) => {
          return {
            key: e.leaveId,
            value: e.leaveName
          }
        })
      } else {
        this.leaveTypeList = [];
      }
    }, () => {
      this.leaveTypeList = [];
    });
  }
}
